import { mapGetters } from 'vuex'
import { settingJournalAtypeAlert, settingJournal } from '@/api/setting'
import { discount, discountJournalId } from '@/api/discount'
import addDialog from './add.dialog.vue'
import journal from '@/api/journal'
import discountVoucher from './discount-voucher.vue'
const columns = [
  {
    title: '',
    enTitle: '',
    width: 140,
    dataIndex: 'symbolType',
    slot: 'symbolType'
  },
  {
    title: '',
    enTitle: '',
    width: 700,
    dataIndex: 'articleTypeList',
    slot: 'articleType'
  },
  {
    title: '',
    enTitle: '',
    width: 100,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    addDialog,
    discountVoucher
  },
  data() {
    return {
      columns,
      dataSource: [],
      alertDate: {},
      inputData: {},
      params: {},
      symbol: {
        GT: '＞',
        LTE: '≤'
      },
      isVisable: false,
      addDiscountVoucherVisable: false,

      isEdit: {
        UNSUBSCRIBED_EFFECTIVE_DATE: false,
        date: false,
        discountVoucher: false,
        DISCOUNT_DAY: false,
        SPECIAL_ISSUE_SHOW: false
      },
      discountVoucherList: [],
      diacounts: [],
      displaySpecialIssue: false,
      displaySpecialIssueV2: false,
      displayReviewerBoard: false,
      displayTopic: false,
      displayEb: false,
      displayConference: false,
      submissionSetting: true,
      options: [
        { label: 'Open', value: true },
        { label: 'Closed', value: false }
      ]
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser',
      personalJournalList: 'getPersonalJournalList'
    })
  },
  watch: {
    journalId: {
      handler(val) {
        if (val) {
          this.getList()
        }
      },
      immediate: true
    },
    user: {
      handler(val) {
        if (val.codeList) {
          this.getList()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      if (!this.journalId || !this.user.codeList) {
        return
      }
      const data = Object.assign({
        journalId: this.journalId
      })
      if (
        this.user.codeList &&
        this.user.codeList.includes(
          'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_TYPE_ALERT'
        )
      ) {
        this.dataSource = await settingJournalAtypeAlert.get(data)
      }
      // console.log(this.user)
      if (
        this.user.codeList &&
        (this.user.codeList.includes(
          'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.ARTICLE_DATE_ALERT'
        ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.UNSUBSCRIBED_EFFECTIVE_DAYS'
          ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_DAY'
          ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SPECIAL_ISSUE_SHOW'
          ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_TOPIC_ON_WEBSITE'
          ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_SPECIAL_ISSUE_APPLICATION_PORTAL'
          ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_EDITORIAL_BOARD_APPLICATION_PORTAL'
          ) ||
          this.user.codeList.includes(
            'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.SHOW_CONFERENCES'
          ))
      ) {
        this.alertDate = await settingJournal.get(data)
        this.params = JSON.parse(JSON.stringify(this.alertDate))
        this.displayTopic = this.params.DISPLAY_TOPIC == 0 ? false : true
        this.displaySpecialIssue =
          this.params.SPECIAL_ISSUE_APPLY_SHOW == 0 ? false : true
        this.displayEb = this.params.EB_APPLY_SHOW == 0 ? false : true
        this.displayConference =
          this.params.CONFERENCES_SHOW == 0 ? false : true
        this.displaySpecialIssueV2 =
          this.params.SPECIAL_ISSUE_DISPLAY == 0 ?false: true
        this.displayReviewerBoard = this.params.REVIEWER_BOARD_DISPLAY==0? false:true
      }
      if (
        this.user.codeList.includes(
          'SYSTEM.JOURNAL_SETTING.GENERAL_SETTING.DISCOUNT_VOUCHER'
        )
      ) {
        const data = await discountJournalId.query(this.journalId)
        this.diacounts = data
        this.discountVoucherList = JSON.parse(JSON.stringify(data))
      }

      const { details } = await journal.query(this.journalId)
      this.submissionSetting = details && details.submited
    },
    add() {
      this.isVisable = true
      this.inputData = {}
    },

    async copy(val) {
      const data = Object.assign({
        journalId: this.journalId,
        id: (val && val.id) || ''
      })
      if (val && val.id) {
        await settingJournalAtypeAlert.copy(data)
        this.$message.success({ title: 'Success', content: 'Copy Sucess!' })
        this.getList()
      } else {
        const journalList = this.personalJournalList.map(item => item.name)
        this.$confirm({
          title: 'Applied Globally',
          content: `Do you want to Apply Globally ${journalList.slice()}？`,
          type: 'warning',
          icon: 'iconduplicate'
        }).then(async () => {
          if (val === 'dateAlert') {
            await settingJournal.copy(data)
          } else {
            await settingJournalAtypeAlert.copy(data)
          }
          this.$message.success({
            title: 'Success',
            content: 'Applied Globally Sucess!'
          })
          this.getList()
        })
      }
    },
    edit(val) {
      this.isVisable = true
      this.inputData = val
    },
    del(val) {
      this.$confirm({
        title: 'Delete Alert',
        content:
          'Are you sure you want to delete this article type alert? Please be aware of once this is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await settingJournalAtypeAlert.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Manuscript Alert has been Deleted!'
        })
        this.getList()
      })
    },

    editAble(type) {
      this.isEdit[type] = true
    },

    confirmType() {
      this.isVisable = false
      this.addDiscountVoucherVisable = false
      this.getList()
    },

    async confirmArticleDate() {
      if (
        !(
          this.params.RECEIVED_REVISED_DATE > 0 &&
          this.params.REVISED_ACCEPT_DATE > 0 &&
          this.params.ACCEPT_PUBLISHED_DATE > 0
        )
      ) {
        this.$message.error({
          title: 'Error',
          content: 'The day can not be less than 0!'
        })
        return
      }
      if (this.isEdit.date) {
        await settingJournal.edit(this.journalId, this.params)
        this.$message.success({
          title: 'Success',
          content: 'This Manuscript Alert has been Saved!'
        })
      }
      this.isVisable = false
      this.isEdit.date = false
      this.getList()
    },

    async confirmSetting(type, e) {
      if (type === 'SPECIAL_ISSUE_SHOW') {
        if (
          !(
            this.params.SPECIAL_CLOSE_PLAN_NUM >= 0 &&
            this.params.SPECIAL_CLOSE_PUBLISH_NUM >= 0 &&
            this.params.SPECIAL_OPEN_PLAN_NUM >= 0 &&
            this.params.SPECIAL_OPEN_PUBLISH_NUM >= 0
          )
        ) {
          this.$message.error({
            title: 'Error',
            content: 'The data can not be less than 0!'
          })
          return
        }
      }

      let content = 'This Manuscript Alert has been Saved!'
      switch (type) {
        case 'SPECIAL_ISSUE_SHOW':
          content = `The Setting has been Saved!`
          if (!this.params[type]) {
            this.params[type] = 0
          }
          break
        case 'SPECIAL_ISSUE_APPLY_SHOW':
          content = `The Setting has been Saved!`
          content = `Update successful!`
          this.params[type] = !e == true ? '1' : '0'
          this.displaySpecialIssue = !this.displaySpecialIssue
          break
        case 'EB_APPLY_SHOW':
          content = `The Setting has been Saved!`
          content = `Update successful!`
          this.params[type] = !e == true ? '1' : '0'
          this.displayEb = !this.displayEb
          break
        case 'CONFERENCES_SHOW':
          content = `The Setting has been Saved!`
          content = `Update successful!`
          this.params[type] = !e == true ? '1' : '0'
          this.displayConference = !this.displayConference
          break
        case 'DISPLAY_TOPIC':
          content = `Update successful!`
          this.params[type] = !e == true ? '1' : '0'
          this.displayTopic = !this.displayTopic
          break
        case 'SPECIAL_ISSUE_DISPLAY':
          content  =  `Update successful!`
          this.params[type] = !e == true ? '1' : '0'
          this.displaySpecialIssueV2 = !this.displaySpecialIssueV2
          break
        case 'REVIEWER_BOARD_DISPLAY':
          content  =  `Update successful!`
          this.params[type] = !e == true ? '1' : '0'
          this.displayReviewerBoard = !this.displayReviewerBoard
          break
      }
      await settingJournal.edit(this.journalId, this.params)
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.isEdit[type] = false
      this.getList()
    },

    async addDiscountVoucher() {
      this.addDiscountVoucherVisable = true
      this.inputData = Object.assign({
        journalId: this.journalId
      })
    },

    async delDiscountVoucher(val) {
      this.$confirm({
        title: 'Are you sure you want to delete it?',
        content:
          'Please be aware of once this is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await discount.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'Deleted successfully!'
        })
        this.getList()
      })
    },
    async confirmDiscountVoucher() {
      const data = this.discountVoucherList
      const flag = data.some(item => {
        return item.discount <= 0
      })
      if (flag) {
        this.$message.error({
          title: 'Error',
          content: 'The discount can not be less than 0!'
        })
        return
      }
      await discount.edit(data)
      this.$message.success({
        title: 'Success',
        content: 'Edit successfully!'
      })
      this.isEdit.discountVoucher = false
      this.getList()
    },
    async cancel() {
      this.isVisable = false
      this.addDiscountVoucherVisable = false
      this.isEdit.date = false
      this.isEdit.UNSUBSCRIBED_EFFECTIVE_DATE = false
      this.isEdit.discountVoucher = false
      this.isEdit.DISCOUNT_DAY = false
      this.isEdit.SPECIAL_ISSUE_SHOW = false
      this.discountVoucherList = JSON.parse(JSON.stringify(this.diacounts))
      this.params = JSON.parse(JSON.stringify(this.alertDate))
    },
    async submissionHandle(result) {
      const params = {
        id: this.journalId,
        submited: result
      }
      await journal.submited(params)
      if (result) {
        this.$message.success({
          title: 'Success',
          content: 'Submission Setting is Open'
        })
      } else {
        this.$message.success({
          title: 'Success',
          content: 'Submission Setting is Closed'
        })
      }
    }
  }
}
